import React from 'react';

/**
 * @typedef {'ai'|'success'|'warning'|'error'|'neutral'|'info'} BadgeVariant
 * @typedef {'sm'|'md'} BadgeSize
 */

const FONT_SIZE = { sm: '0.6875rem', md: '0.75rem' };
const PADDING   = { sm: '1px 6px', md: '2px 8px' };

/**
 * Semantic status badge using design-system CSS variables.
 * Does NOT rely on antd Tag internals — purely CSS-var-driven.
 *
 * @param {object}          props
 * @param {BadgeVariant}    [props.variant='neutral']
 * @param {BadgeSize}       [props.size='md']
 * @param {React.ReactNode} [props.icon]
 * @param {React.ReactNode} props.children
 */
const Badge = ({
  variant = 'neutral',
  size = 'md',
  icon,
  children,
  className = '',
  style,
  ...rest
}) => (
  <span
    {...rest}
    className={`badge-base badge-${variant} ${className}`.trim()}
    style={{
      fontSize: FONT_SIZE[size],
      padding: PADDING[size],
      lineHeight: 1.3,
      ...style,
    }}
  >
    {icon && <span className="badge-icon" aria-hidden="true">{icon}</span>}
    {children}
  </span>
);

export default Badge;
